export enum UserExtensionQueueStatus {
    PAUSED = 'PAUSED',
    AVAILABLE = 'AVAILABLE',
}
